/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { updateWhatsAppBusinessProfileDataVerticalSchema } from './UpdateWhatsAppBusinessProfileDataVerticalSchema'

export const updateWhatsAppBusinessProfileDataSchema = z.object({
	vertical: updateWhatsAppBusinessProfileDataVerticalSchema,
	description: z.string().nullable().optional(),
	address: z.string().nullable().optional(),
	email: z.string().email().nullable().optional(),
	websites: z.array(z.string()).nullable().optional(),
	profilePicture: z.unknown().nullable().optional(),
})

export type UpdateWhatsAppBusinessProfileDataSchema = z.infer<typeof updateWhatsAppBusinessProfileDataSchema>
